export const GOAL_UID = 'goal_uid';
export const GOAL_NAME = 'goal_name';
export const IS_SUBSCRIPTION_ACTIVE = 'is_subscription_active';
export const SUBSCRIPTION_DURATION = 'subscription_duration';
export const SUBSCRIPTION_END_DATE = 'subscription_end_date';
export const LANGUAGE = 'language';
export const START_DATE = 'start_date';
export const END_DATE = 'end_date';
export const NAME = 'name';
export const EDUCATOR_UID = 'educator_uid';
export const EDUCATOR_USERNAME = 'educator_username';
export const BATCH_UID = 'batch_uid';
export const BATCH_TITLE = 'batch_title';
export const TEST_SERIES_UID = 'test_series_uid';
export const TEST_SERIES_TITLE = 'test_series_title';
export const COURSE_UID = 'course_uid';
export const COURSE_TITLE = 'course_title';
export const IS_ENROLLED = 'is_enrolled';
